<template>
    <form class="flex flex-col gap-5" @submit.prevent="submit">
        <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
            <input
                id="name"
                v-model="user.name"
                :placeholder="$t('Name')"
                class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                required
            />
        </div>
        <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700" for="email">{{ $t('Email') }}</label>
            <input
                id="email"
                v-model="user.email"
                :placeholder="$t('Email')"
                class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                required
                type="text"
            />
        </div>
        <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700" for="password">{{ $t('Password') }}</label>
            <input
                id="password"
                v-model="user.password"
                class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                placeholder="******************"
                required
                type="password"
            />
        </div>
        <div class="relative">
            <label class="block text-sm font-medium leading-5 text-gray-700" for="password_confirmation">{{ $t('Confirm password') }}</label>
            <input
                id="password_confirmation"
                v-model="user.password_confirmation"
                class="form-input block w-full mt-1 sm:text-sm sm:leading-5"
                placeholder="******************"
                required
                type="password"
            />
        </div>
        <div class="pt-2">
            <button id="submit-register" class="btn-stage-primary min-h-[3rem] w-full justify-center" data-style="zoom-in" type="submit">
                {{ $t('Create account') }}
            </button>
        </div>
        <div class="flex flex-col gap-3 pt-1.5">
            <p class="text-[0.95rem] leading-[1.6] text-ink">
                {{ $t('Do you already have an account?') }}<br>
                <router-link class="font-semibold text-[#202830] no-underline hover:text-[#14191f]" to="/auth/login">
                    {{ $t('Sign In') }}
                </router-link>
            </p>
        </div>
    </form>
</template>

<script>
import {customerHomePath} from "@/utils/access-context";

export default {
    name: "register",
    metaInfo() {
        return {
            title: this.$i18n.t('Register')
        }
    },
    data() {
        return {
            user: {
                name: null,
                email: null,
                password: null,
                password_confirmation: null,
                captcha: null
            }
        }
    },
    methods: {
        submit() {
            const self = this;
            if (self.$store.state.settings.recaptcha_enabled) {
                self.$recaptcha('register').then(function (token) {
                    self.user.captcha = token;
                    self.register();
                });
            } else {
                self.register();
            }
        },
        register() {
            const self = this;
            const ladda = Ladda.create(document.querySelector('#submit-register'));
            ladda.start();
            axios.post('api/auth/register', this.user).then(function (response) {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Account created successfully').toString(),
                    type: 'success'
                })
                self.$store.commit('login', response.data);
                const accessContext = self.$store && self.$store.state ? self.$store.state.access : null;
                self.$router.push(customerHomePath(accessContext));
            }).catch(function () {
                self.user.password = null;
                self.user.password_confirmation = null;
            });
        }
    }
}
</script>
